import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { Unit } from '../types'

export interface UnitsReducer {
  units: Unit[]
  selectedUnitId: string | null
}

const initialState: UnitsReducer = {
  units: [],
  selectedUnitId: null
}

export const FETCH_UNITS = createAction('units_reducer/fetch_units')
export const FETCH_UNITS_SUCCESS = createAction<Unit[]>('units_reducer/fetch_units_success')
export const FETCH_UNITS_FAIL = createAction('units_reducer/fetch_units_fail')

interface CreateUnitPayload {
  name: string
  description: string
  image: string
}

export type CreateUnitActionType = PayloadAction<CreateUnitPayload>
export const CREATE_UNIT = createAction<CreateUnitPayload>('units_reducer/create_unit')
export const CREATE_UNIT_SUCCESS = createAction<Unit>('units_reducer/create_unit_success')
export const CREATE_UNIT_FAIL = createAction('units_reducer/create_unit_fail')

interface UpdateUnitPayload {
  id: string
  name: string
  description: string
  image: string
}
export type UpdateUnitActionType = PayloadAction<UpdateUnitPayload>
export const UPDATE_UNIT = createAction<UpdateUnitPayload>('units_reducer/update_unit')
export const UPDATE_UNIT_SUCCESS = createAction<Unit>('units_reducer/update_unit_success')
export const UPDATE_UNIT_FAIL = createAction('units_reducer/update_unit_fail')

interface SelectUnitActionType {
  unitId: string
}
export const SELECT_UNIT = createAction<SelectUnitActionType>('units_reducer/select_unit')

export const unitsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_UNITS_SUCCESS, (state, action) => {
      return { ...state, units: action.payload }
    })
    .addCase(SELECT_UNIT, (state, action) => {
      return { ...state, selectedUnitId: action.payload.unitId }
    })
    .addCase(CREATE_UNIT_SUCCESS, (state, action) => {
      return { ...state, units: [...state.units, action.payload] }
    })
    .addCase(UPDATE_UNIT_SUCCESS, (state, action) => {
      const newUnit = action.payload
      const oldUnit = state.units.find((unit) => unit.id === newUnit.id)
      if (!oldUnit) return state
      newUnit.image = newUnit.image === null ? oldUnit.image : newUnit.image
      return { ...state, units: state.units.map((unit) => (unit.id === action.payload.id ? newUnit : unit)) }
    })
})
